<app-header
  icon="fas fa-images"
  text="Bilder"
  sub="Nutzen Sie Bilder, um Ihren Teasern in Ihrer einen eigenen Touch zu verleihen."></app-header>
<p-divider />
@if (store.asArray(); as images) {
  @if (images.length > 0) {
    @if (images.length >= limit) {
      <app-alert severity="info" header="Limit erreicht" [canToggle]="false">
        <p>
          Sie können maximal {{ limit }} Bilder anlegen. Um weitere Bilder
          anzulegen, löschen oder aktualisieren Sie bitte ungenutzte Bilder.
        </p>
      </app-alert>
    }
    <p-table
      #imageTable
      [globalFilterFields]="['title']"
      [loading]="loading"
      [value]="images">
      <ng-template pTemplate="caption">
        <app-table-list-caption
          [disableAddButton]="images.length >= 15"
          [searchWord]="searchWord"
          (clearTable)="clear(imageTable)"
          (search)="
            imageTable.filterGlobal($event, 'contains')
          "></app-table-list-caption>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th></th>
          <th>Titel</th>
          <th>
            <span class="flex align-items-center gap-2">
              <i
                class="fas fa-info-circle"
                pTooltip="Sind Bilder referenziert, sollten Sie diese nicht löschen, da Sie dadurch Ansichten beschädigen können."></i>
              Referenzen
            </span>
          </th>
          <th>Aktionen</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-image>
        <tr>
          <td class="w-6rem">
            <div class="p-card p-0 w-6rem">
              <img
                [ngSrc]="getSrc(image.src)"
                [alt]="image.src"
                fill
                priority
                style="
                  position: static;
                  object-fit: cover;
                  object-position: 50% 50%;
                " />
            </div>
          </td>
          <td>
            <span class="flex align-items-center gap-3">
              {{ image.title }}</span
            >
          </td>
          <td>
            @if (
              bookmarkStore.numberOfBookmarkReferencesByImageId(image._id);
              as bookmarkReferences
            ) {
              <p-tag severity="warning"
                ><span class="flex align-items-center gap-2"
                  ><i class="fas fa-note-sticky"></i> {{ bookmarkReferences }}
                  {{ bookmarkReferences > 1 ? 'Ansichten' : 'Ansicht' }}
                </span></p-tag
              >
            } @else {
              <p-tag severity="secondary"
                ><span class="flex align-items-center gap-2"
                  ><i class="fas fa-note-sticky"></i> nicht referenziert</span
                ></p-tag
              >
            }
          </td>
          <td>
            <app-table-list-actions
              [item]="image"
              (confirm)="confirm($event, image, image.title)">
            </app-table-list-actions>
          </td>
        </tr>
      </ng-template>
    </p-table>
  } @else {
    <app-alert header="Keine Bilder gefunden" [canToggle]="false">
      <p>
        Nutzen Sie Bilder, um Ihren Teasern in Ihrer einen eigenen Touch zu
        verleihen.
      </p>
      <p>
        <a [routerLink]="[{ outlets: { bearbeiten: 'neu' } }]"
          >Ihr erstes Bild anlegen.</a
        >
      </p>
    </app-alert>
  }
}

<p-sidebar
  (onHide)="onOverlayClose()"
  position="right"
  [modal]="false"
  [styleClass]="'w-9'"
  [visible]="editFormOverlay">
  <ng-template pTemplate="header">
    <app-header
      [icon]="editFormOverlayIcon"
      [text]="editFormOverlayHeader"></app-header
  ></ng-template>

  <ng-container *ngIf="editFormOverlay">
    <router-outlet name="bearbeiten"></router-outlet>
  </ng-container>
</p-sidebar>
<app-mask [visible]="editFormOverlay" (click)="onOverlayClose()"></app-mask>
